import React from 'react';
import { TextField, Autocomplete, Box, Avatar, Typography, CircularProgress } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import useHook from './useHook';
import styles from './styles.module.scss';

const Buscador = () => {

  const {
    options,
    inputValue,
    loading,
    handleInputChange,
    search,
    goToProducto,
  } = useHook();

  return (
    <form className={styles.formulario}>
      <div className={styles.campo}>
        <Autocomplete
          fullWidth
          freeSolo
          inputValue={inputValue}
          onInputChange={handleInputChange}
          options={options}
          loading={loading}
          loadingText="Buscando..."
          getOptionLabel={(option: any) => option?.attributes?.nombre || ''}
          onChange={(_e, newValue: any) => {
            if (newValue) {
              goToProducto(newValue);
            }
          }}
          renderOption={(props, option: any) => {
            const nombre = option?.attributes?.nombre;
            const imageUrl = option?.attributes?.fotos?.data[0]?.attributes?.url;
            return (
              <Box
                component="li"
                {...props}
                sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}
              >
                {imageUrl && (
                  <Avatar
                    src={imageUrl}
                    alt={nombre}
                    sx={{ width: 32, height: 32, borderRadius: '6px' }}
                    variant="square"
                  />
                )}
                <Typography variant="body2">{nombre}</Typography>
              </Box>
            );
          }}
          sx={{
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              variant="outlined"
              color="primary"
              placeholder="¿Qué estás buscando?"
              inputProps={{
                ...params.inputProps,
                'aria-label': 'Buscar productos'
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  search(e);
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress size={16} sx={{ mr: 1 }} />}
                    <IconButton
                      size="small"
                      onClick={(e) => search(e)}
                      color="secondary"
                      aria-label="Buscar"
                    >
                      <SearchIcon />
                    </IconButton>
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
              sx={{
                background: '#fff',
                borderRadius: '100px',
                border: '1px solid #cecece',
                pr: 1
              }}
            />
          )}
        />
      </div>
    </form>
  );
};

export default Buscador;
